module.exports = __webpack_public_path__ + "static/media/delete.38e48220.svg";